import React, { useState } from 'react';
import ActionButton from '~components/atoms/ActionButton';
import Table from '~components/molecules/Table';
import UtilFunctions from '~utils/functions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { MetalTypeEnum, ModuleEnum, PermissionsEnum, TransferStatusEnum } from '~utils/enums';

import * as Styles from './_projectApprovalTableStyles.module.scss';
import combinedActions from '~redux/combinedActions';
import { TupdateTransferStatusReduxParams } from '~types/feat/approval';
import ViewSerialNoModalModal from '~components/molecules/ViewSerialNoModal';

const TransfersApprovalTable = () => {
    const dispatch = useAppDispatch();

    const {
        Misc:
        {
            dateTimeFormat,
            renderPendingTransferStatusChip,
        },
    } = UtilFunctions;

    const transferStatusLabelMap: Record<TransferStatusEnum, string> = {
        [TransferStatusEnum.PendingDeliver]: 'Pending Deliver',
        [TransferStatusEnum.PendingReceive]: 'Pending Receive',
        [TransferStatusEnum.Approved]: 'Approved',
        [TransferStatusEnum.RejectedDeliver]: 'Rejected Deliver',
        [TransferStatusEnum.RejectedReceive]: 'Rejected Receive',
    };

    const pendingTransfersListing = useAppSelector(state => state.approval.pendingTransferListing.data);
    const getPendingTransfersIsLoading = useAppSelector(state => state.approval.loadings.getpendingTransferListing);

    const access = useAppSelector(state => state.auth.userDetails.access);
    const hasEditAccess = access.find(item => item.permission === PermissionsEnum.Edit)?.modules.find(module => module === ModuleEnum.Approval);

    const [serialNoList, setSerialNoList] = useState<string[]>([]);
    const [isSerialNoModalOpen, setIsSerialNoModalOpen] = useState(false);

    const setTempUpdateTransfersState = (data: TupdateTransferStatusReduxParams) => dispatch(combinedActions.approvalSetTempUpdateTransferState(data));
    const setConfirmUpdateStatusModalIsOpen = (open: boolean) => dispatch(combinedActions.approvalSetConfirmupdateTransferStatusModalIsOpen(open));

    const handleApproveClick = (data: TupdateTransferStatusReduxParams) => {
        setConfirmUpdateStatusModalIsOpen(true);
        setTempUpdateTransfersState(data);
    };

    const handleRejectClick = (data: TupdateTransferStatusReduxParams) => {
        setConfirmUpdateStatusModalIsOpen(true);
        setTempUpdateTransfersState(data);
    };

    const getRejectStatus = (currentStatus: TransferStatusEnum): TransferStatusEnum => {
        return currentStatus === TransferStatusEnum.PendingDeliver
            ? TransferStatusEnum.RejectedDeliver
            : TransferStatusEnum.RejectedReceive;
    };

    const tableHeader = [
        'TRANSFER ID',
        'SOURCE BRANCH',
        'TARGET BRANCH',
        'PRODUCT NAME',
        'QUANTITY',
        'SERIAL NUMBER',
        'STATUS',
        'TRANSFER DATE',
        // 'CREATED AT',
        'ACTION',
    ];

    const renderActionButton = (id: number, status:TransferStatusEnum ) => {
        if (status === TransferStatusEnum.PendingDeliver || status === TransferStatusEnum.PendingReceive){
            return (
                <div
                    className={Styles['action-button-container']}
                >
                    {hasEditAccess
                    && (
                        <ActionButton
                            label='Approve'
                            onClick={() => handleApproveClick({ id, status: TransferStatusEnum.Approved })}
                            className={`${Styles['action-button']} ${Styles.approve}`}
                        />
                    )
                    }

                    {hasEditAccess
                    && (
                        <ActionButton
                            label='Reject'
                            onClick={() =>
                                handleRejectClick({
                                    id,
                                    status: getRejectStatus(status),
                                })
                            }
                            className={`${Styles['action-button']} ${Styles.reject}`}
                        />
                    )
                    }
                </div>
            );
        }

        return '-';

    };

    const tableBody = pendingTransfersListing.map(item => {
        const {
            transferId,
            branchFromName,
            branchToName,
            productName,
            amount,
            serialNo,
            status,
            createdAt,
            metalType,
        } = item;

        const handleViewSerialNo = () => {
            setIsSerialNoModalOpen(true);
            setSerialNoList(serialNo);
        };

        const renderSerialNo = () => {
            return (
                <ActionButton
                    testId='approval-transfer-view-serialNo-modal-button'
                    key={transferId}
                    label='View'
                    onClick={() => handleViewSerialNo()}
                />
            );
        };

        return {
            className: metalType === MetalTypeEnum.Gold
                ? Styles['gold-row']
                : '',
            cells: [
                transferId,
                branchFromName,
                branchToName,
                productName,
                amount,
                renderSerialNo(),
                renderPendingTransferStatusChip(
                    status,
                    transferStatusLabelMap[status],
                ),
                createdAt ? dateTimeFormat(createdAt) : '-',
                renderActionButton(transferId, status),
            ],
        };
    });

    return (
        <>
            <Table
                header={tableHeader}
                body={tableBody}
                isLoading={getPendingTransfersIsLoading}
            />

            <ViewSerialNoModalModal
                isOpen={isSerialNoModalOpen}
                onClose={() => setIsSerialNoModalOpen(false)}
                serialNo={serialNoList}
            />
        </>
    );
};

export default TransfersApprovalTable;
